import { render, staticRenderFns } from "./uf_main_main_manufacturers_abroad.vue?vue&type=template&id=429310e8&scoped=true"
import script from "./uf_main_main_manufacturers_abroad.vue?vue&type=script&lang=js"
export * from "./uf_main_main_manufacturers_abroad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429310e8",
  null
  
)

export default component.exports